import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface WidgetButtonOpenIconProps {
  isImageIcon: boolean;
  icon: string;
}

const OpenIconComponent: React.FC<WidgetButtonOpenIconProps> = ({
  isImageIcon,
  icon,
}) => {
  return isImageIcon ? (
    <img
      src={icon}
      alt="Chat widget icon"
      className="peptalk-widget-button-icon"
    />
  ) : (
    <span className="peptalk-widget-button-text">{icon}</span>
  );
};

export const OpenIcon: React.FC<WidgetButtonOpenIconProps> = (
  props: WidgetButtonOpenIconProps
) => {
  const Component = useCustomComponent({
    componentName: 'WidgetButtonIcon',
    Component: OpenIconComponent,
  });

  return <Component {...props} />;
};
